import { render } from "./receipt-list-area.vue?vue&type=template&id=46f943c0"
import script from "./receipt-list-area.vue?vue&type=script&lang=js"
export * from "./receipt-list-area.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__